import { combineReducers } from "redux";
import UserReducer from "./user/reducers";

const rootReducer = combineReducers({
  user: UserReducer,
});

export default rootReducer;
